import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const ArrowIcon: FC<IconProps> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="11" height="7" fill="none">
        <path
            fill="currentColor"
            d="M10.434.434a.8.8 0 0 1 0 1.132L5.91 6.09a.8.8 0 0 1-1.132 0L.252 1.566A.8.8 0 0 1 1.383.434l3.96 3.96 3.96-3.96a.8.8 0 0 1 1.131 0Z"
        />
    </svg>
);